module.exports = __webpack_public_path__ + "static/blink_dog-2706141f2ce8ae7e51acdc96e744d776.jpeg";